import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EsignOverlayService {
  private readonly openSubject = new Subject<any>();
  private readonly successSubject = new Subject<void>();

  open(payload: any = null): void {
    this.openSubject.next(payload);
  }

  get open$() {
    return this.openSubject.asObservable();
  }

  notifySuccess(): void {
    this.successSubject.next();
  }

  get onSuccess$() {
    return this.successSubject.asObservable();
  }
}
